<ds-stepper *ngIf="!isResponsive" orientation="vertical" [steps]="steps"></ds-stepper>
<ds-stepper *ngIf="isResponsive" orientation="vertical-dropdown" [(expanded)]="stepperExpanded" [steps]="steps"></ds-stepper>
